import { CONSENT_MODES } from 'api/consent-modes/modes';

// Shared by the insert and update pipeline_integration mutation builders.
// Returns the `pipeline_integration_consent` fragment when either field is set, else `{}`.
// When `pipelineIntegrationConsentId` is provided, returns the upsert shape (data.id + on_conflict);
// otherwise returns the plain nested-insert shape.
// DB default for `mode` is 'CONSENT_MODE_ACE'.
export default function buildConsentVars({ pipelineIntegrationConsentId, consentCategoryId, consentMode }) {
  if (!consentCategoryId && !consentMode) {
    return {};
  }

  const data = {};

  if (pipelineIntegrationConsentId) {
    data.id = pipelineIntegrationConsentId;
  }

  if (consentMode) {
    data.mode = consentMode;
  }

  // external cannot have a category
  data.consentCategoryId = null;

  if (consentCategoryId && consentMode !== CONSENT_MODES.external) {
    data.consentCategoryId = consentCategoryId;
  }

  const consent = { data };

  // update / upsert only
  if (pipelineIntegrationConsentId) {
    const updateColumns = ['consentCategoryId'];

    if (consentMode) {
      updateColumns.push('mode');
    }

    consent.on_conflict = {
      constraint: 'pipeline_integration_consents_pkey',
      update_columns: updateColumns,
    };
  }

  return { pipeline_integration_consent: consent };
}
